import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/business-type`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchBusinessTypes = (payload) => apiHelper(API_URL, 'GET', payload);
export const createBusinessType = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchBusinessType = (businessTypeId) => apiHelper(`${API_URL}/${businessTypeId}`, 'GET');
export const modifyBusinessType = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deleteBusinessTypeApi = (businessTypeId) => apiHelper(`${API_URL}/${businessTypeId}`, 'DELETE');
export const changeStatus = (businessTypeId) => apiHelper(`${API_URL}/change-status/${businessTypeId}`, 'POST');